import React from "react"
import ReactDOM from "react-dom"
import { createRoot } from "react-dom/client"

// react-transition-group v4 calls ReactDOM.findDOMNode which was removed in React 19.
// This polyfill restores it so reactstrap Carousel animations don't crash the page.
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (component) => {
    if (component === null || component === undefined) return null
    if (component instanceof Element) return component
    return null
  }
}

// PayPal's `Buttons.driver("react", { React, ReactDOM })` internally calls
// ReactDOM.render and ReactDOM.unmountComponentAtNode — both removed in
// React 19. Without these polyfills, mounting the SDK button throws
// "Expected element to be passed to render iframe" and the buttons never
// appear. We polyfill via createRoot, caching the root per container so a
// container can be re-rendered without recreating the root each call.
if (!ReactDOM.render) {
  ReactDOM.render = (element, container, callback) => {
    if (!container) return null
    let root = container.__reactRoot
    if (!root) {
      root = createRoot(container)
      container.__reactRoot = root
    }
    root.render(element)
    if (typeof callback === "function") setTimeout(callback, 0)
    return null
  }
}
if (!ReactDOM.unmountComponentAtNode) {
  ReactDOM.unmountComponentAtNode = (container) => {
    if (!container) return false
    const root = container.__reactRoot
    if (root) {
      root.unmount()
      delete container.__reactRoot
      return true
    }
    return false
  }
}
import { BrowserRouter } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
// import { createBrowserHistory } from "history"
import "react-datepicker/dist/react-datepicker.css"
import "react-multi-carousel/lib/styles.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import App from "./Contents/App"
import ScrollToTop from "./Components/Common/ScrollToTop"
import { PurchaseProvider } from "./Context/purchase"
import { CartProvider } from "./Context/cart"
import { UserProvider } from "./Context/user"
import { AppDataProvider } from "./Context/appData"
import { RedemptionDataProvider } from "./Context/redemption"

// const history = createBrowserHistory()
const container = document.getElementById("root")
const root = createRoot(container)

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop>
        <AppDataProvider>
          <RedemptionDataProvider>
            <UserProvider>
              <PurchaseProvider>
                <CartProvider>
                  <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    limit={1}
                  />
                  <App />
                </CartProvider>
              </PurchaseProvider>
            </UserProvider>
          </RedemptionDataProvider>
        </AppDataProvider>
      </ScrollToTop>
    </BrowserRouter>
  </HelmetProvider>
)
